import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CommonComponentsModule } from '../../../components/common/common-components.module';
import { getSessionId, saveToStorageAsync } from '../../../helpers/storageUtils';
import { CreateLead } from '../../../Models/createLead';
import { DatosGenerales } from '../../../Models/datosGenerales';
import { LeadResponse } from '../../../Models/leadResponse';
import { YaTenemosEstado } from '../../../Models/ya-tenemos-datos-estado.enum';
import { FEEDBACK } from '../../../routes.constans';
import { LeadsService } from '../../../services/Leads/leads.service';
import { selectData } from '../../../storage/Lead/data.selectors';
import { BannerAppComponent } from '../../banner-app/banner-app.component';
import { AutorizationModalComponent } from '../../common/autorization-modal/autorization-modal.component';
import { FooterAppComponent } from '../../footer-app/footer-app.component';

@Component({
  selector: 'app-crea-lead',
  standalone: true,
  imports: [
    FooterAppComponent,
    BannerAppComponent,
    ReactiveFormsModule,
    CommonModule,
    CommonComponentsModule,
    NgbModule,
  ],
  templateUrl: './crea-lead.component.html',
  styleUrl: './crea-lead.component.scss',
})
export class CreaLeadComponent implements OnInit {
  @ViewChild('nombreCliente') nombreCliente2!: ElementRef;
  @ViewChild('numCelular') numCelular2!: ElementRef;
  @ViewChild('correo') correoElec2!: ElementRef;
  emailPattern = environment.PATTERN_EMAIL;
  celularPattern = environment.PATTERN_CELULAR;

  completo = '';
  leadId = '';
  sessionId = '';

  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;
  leadResponse: LeadResponse | null = null;
  datosLead: CreateLead = {
    plate: '',
    confirm_plate: '',
    owner_borndate: '',
    circulation_zone_id: '',
    use_type: '',
    accept_tos: false,
    name: '',
    mobile_phone: '',
    assessor_code: 0,
  };

  formulario: FormGroup = new FormGroup({
    nombreCliente: new FormControl('', [Validators.required]),
    numCelular: new FormControl('', [
      Validators.minLength(6),
      Validators.maxLength(10),
      Validators.pattern(this.celularPattern),
    ]),
    correo: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern(this.emailPattern),
    ]),
    flexCheckAutoriza: new FormControl(false),
  });
  codAsesor = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private leadServices: LeadsService,
    private modalService: NgbModal,
  ) {
    this.datosGenerales$ = this.store.select(selectData);
  }

  ngOnInit(): void {
    this.sessionId = getSessionId().toString();
    this.datosGenerales$.subscribe((data) => {
      this.datosGenerales = data;
    });
  }

  valNombre = false;
  valNombre2 = true;
  validacionNombre() {
    if (this.formulario.get('nombreCliente')?.value === '') {
      this.valNombre = !this.valNombre;
      this.valNombre2 = !this.valNombre2;
    } else {
      this.valNombre = false;
      this.valNombre2 = true;
    }
  }

  valCelular = false;
  valCelular2 = true;
  validacionCelular() {
    if (this.formulario.get('numCelular')?.value === '') {
      this.valCelular = !this.valCelular;
      this.valCelular2 = !this.valCelular2;
    } else {
      this.valCelular = false;
      this.valCelular2 = true;
    }
  }

  valEmail = false;
  valEmail2 = true;
  validacionEmail() {
    if (this.formulario.get('correo')?.value === '') {
      this.valEmail = !this.valEmail;
      this.valEmail2 = !this.valEmail2;
    } else {
      this.valEmail = false;
      this.valEmail2 = true;
    }
  }

  get nombreNoValido() {
    return (
      this.formulario.get('nombreCliente')?.invalid && this.formulario.get('nombreCliente')?.touched
    );
  }

  get correoNoValido() {
    return this.formulario.get('correo')?.invalid && this.formulario.get('correo')?.touched;
  }

  get cedularNoValido() {
    return this.formulario.get('numCelular')?.invalid && this.formulario.get('numCelular')?.touched;
  }

  get formularioNoValido() {
    return this.formulario.invalid;
  }

  siguientePagina() {
    // this.datosLead = this.datosGenerales?.Lead;
    this.datosLead.assessor_code = this.datosGenerales?.Lead.assessor_code ?? 0;
    this.datosLead.plate = this.datosGenerales?.Lead.plate ?? '';
    this.datosLead.confirm_plate = this.datosGenerales?.Lead.confirm_plate ?? '';
    this.datosLead.owner_borndate =
      this.datosGenerales?.LeadResponse?.data?.lead?.owner_borndate ?? '';
    this.datosLead.circulation_zone_id = this.datosGenerales?.Lead.circulation_zone_id ?? '';
    this.datosLead.use_type = this.datosGenerales?.Lead.use_type ?? '';
    this.datosLead.accept_tos = true;
    this.datosLead.name = this.formulario.get('nombreCliente')?.value;
    this.datosLead.mobile_phone = this.formulario.get('numCelular')?.value.toString();

    if (this.datosLead) {
      this.leadServices.postCrearLeads(this.datosLead, this.sessionId).subscribe(async (data) => {
        this.leadResponse = data;
        if (this.leadResponse) {
          await saveToStorageAsync(
            'cotizacion_pausa_estado',
            YaTenemosEstado.LEAD_ABANDONO_RESUMEN,
            'session',
          );
          this.router.navigate([FEEDBACK]);
        }
      });
    } else {
      // Handle the case where datosLead is undefined
      console.error('datosLead is undefined');
    }
  }

  openModal() {
    const modalRef = this.modalService.open(AutorizationModalComponent, { size: 'lg' });
    modalRef.componentInstance.title = 'Política de privacidad y Tratamiento de datos personales';
    modalRef.componentInstance.close.subscribe(() => {
      modalRef.close();
    });
  }

  blockUnicode(event: KeyboardEvent) {
    // Bloquea ñ y Ñ
    if (event.key === 'ñ' || event.key === 'Ñ') {
      event.preventDefault();
    }
  }
}
